{
  "0154a028a8dc3a3e": "Rules & Expectations",
  "0b074018a514be89": "Error updating automated first-shift messages. Please try again later.",
  "1509f561f2416598": "Save",
  "1651031bf58d8eea": "Regenerate",
  "19766ed6ccb2f4a3": "Cancel",
  "1c344f753efd4691": "Your message has been updated.",
  "2f261331efb5e649": "When enabled, send first-time professionals a summary of your rules 24 and 2 hours before their first shift.",
  "322380c1273e3abd": "You have unsaved changes. Are you sure you want to leave?",
  "413aa3282b04a4c8": "We couldn't load this message. Please try again.",
  "49e49bb4401e67bd": "Generate",
  "6533af23e0258a45": "Your messages have not been generated yet.",
  "6d9e92d79b8f2d3b": "Generating your reminder messages. This may take a moment.",
  "6f38236b0918c7b0": "Message cannot be empty.",
  "77ead13550b888df": "Rules and Expectations",
  "9a3999b7ebc7c547": "Edit {{title}} message",
  "9a39b66545015463": "Save updates",
  "a58e3d6b07cf09f0": "Day before shift",
  "b6e8e2cee85d9d41": "Edit {{title}} message content",
  "c4452f4d6323d651": "We couldn't start generating. Please try again.",
  "c6e186268b29007e": "Your rules and expectations have been saved.",
  "cce7f995d327083a": "Enable automated first-shift messages",
  "d5b0a9c99513256f": "We couldn't save your changes. Please try again.",
  "dcf57b1dfdd401b2": "2h before shift",
  "e963db70171393b6": "We couldn't generate this message. Please, fix any issues your rules might contain, and try again.",
  "eadcb509d415d4c8": "Your permission level does not allow you to edit the information on this page. If you want to edit this page you may ask your administrator to update your role in the platform.",
  "f7ee7ef260e751b8": "Generating message…"
}
